
import store from '@/store/index'

export default function setup() {
  try{
    store.dispatch('setUpInterceptors')
  }catch(e){
    console.log(e);
  }
}